var _defs, _circle, _line, _line2, _line3, _line4, _line5, _path, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunnyMist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efcc00;}.cls-2,.cls-4,.cls-5{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-2{stroke:#efcc00;}.cls-3{fill:#e0e0e0;}.cls-4{stroke:#b9c1c6;}.cls-5{stroke:#a5a9aa;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 32,
    r: 17
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32,
    x2: 32,
    y1: 5,
    y2: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59,
    x2: 53,
    y1: 32,
    y2: 32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11,
    x2: 5,
    y1: 32,
    y2: 32
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 51.09,
    x2: 46.85,
    y1: 12.91,
    y2: 17.15
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.15,
    x2: 12.91,
    y1: 17.15,
    y2: 12.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.25,46.25a20.18,20.18,0,0,1-16-9.75H15.62A17,17,0,0,0,41.1,46.34C40.81,46.31,40.54,46.27,40.25,46.25Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 25.5,
    x2: 13.83,
    y1: 36.5,
    y2: 36.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7.54,
    x2: 19.22,
    y1: 41.5,
    y2: 41.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4.85,
    x2: 53.86,
    y1: 46.5,
    y2: 46.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 34.49,
    x2: 55.65,
    y1: 51.5,
    y2: 51.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4.85,
    x2: 27.3,
    y1: 51.5,
    y2: 51.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 26.4,
    x2: 45.75,
    y1: 56.5,
    y2: 56.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.64,
    x2: 20.12,
    y1: 56.5,
    y2: 56.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.61,
    x2: 30.89,
    y1: 41.5,
    y2: 41.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunnyMist);
export default __webpack_public_path__ + "static/media/sunnyMist.8e2b7f59f939fea383b57e2e8f57acd8.svg";
export { ForwardRef as ReactComponent };